<template>
    <div v-if="product">
        <div class="panel panel-default">
            <div class="panel-body">
                    <div class="col-xs-12 col-sm-6">
                        <div class="well">

                            <template v-if="product.images.length">
                                <span v-for="image in product.images">
                                    <a href="#" @click.prevent="zoomImage(image)"><img :src="image.thumb_url" :alt="image.filename" class=""></a>
                                </span>
                            </template>
                            <template v-if="product.images.length == 0">
                                <div class="h5">There are no images for this product</div>
                            </template>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <h2>{{ product.name }}</h2>
                        <h4>{{ product.price | currency }}</h4>
                        <ul class="product-variants" v-if="product.variants.length">
                            <li v-for="(variantType, index) in productVariants()" class="row">
                                <div class="col-sm-12">
                                    <label :for="variantType.label">{{ variantType.label }}</label>
                                    <select :id="variantType.label" class="form-control select2" v-model="product.selectedVariants[index]">
                                        <option v-for="variant in variantType.variants" :value="variant">{{ variant.value }} <span v-if="variant.price > 0">+{{ (variant.price || product.price) | currency }}</span></option>
                                    </select>
                                </div>
                            </li>
                        </ul>

                        <div class="form-group" v-if="product.personalised">
                            <label :for="personalisation">Personalisation</label>
                            <input class="form-control" type="text" :id="personalisation" :name="personalisation" v-model="product.personalisation" />
                        </div>

                        <p>
                            <button @click="add()" class="btn btn-primary">Add to Basket</button>
                        </p>
                        <p>{{ product.description }}</p>
                    </div>
            </div>
        </div>
        <vuedal></vuedal>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { mapActions } from 'vuex';
    import { default as Vuedals, Component as Vuedal, Bus as VuedalsBus } from 'vuedals';

    Vue.use(Vuedals);

    export default {
        components: {
            Vuedal
        },

        props: [
            'productId'
        ],

        data: function () {
            return {
                product: null
            };
        },

        mounted() {
            this.getProduct();
        },

        methods: {
            getProduct() {
                axios.get(`/api/v1/products/${this.productId}`).then((response) => {
                    let product = response.data;
                    product.variantsDisplay = false;
                    product.selectedVariants = [];
                    product.personalisation = '';

                    this.product = product;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading club products.', type: 'error'});
                });
            },

            add() {
                if (this.productVariants().length != this.product.selectedVariants.length) {
                    this.$message({message: 'You have to choose product variants.', type: 'error'});
                    return false;
                }

                this.addToCart(this.product);
                this.product.selectedVariants = [];
            },

            productVariants() {
                let variantTypes = _.map(_.uniqBy(this.product.variants, function (variant) {
                    return variant.label;
                }), (variantType) => {
                    return { label: variantType.label };
                });

                for (let variantType of variantTypes) {
                    variantType.variants = _.filter(this.product.variants, ['label', variantType.label]);
                }

                return variantTypes;
            },

            zoomImage(image) {
                this.$vuedals.$emit('new', {
                    name: 'image-modal',
                    title: this.product.name,
                    props: {
                        image: image,
                    },
                    size: 'xl',
                    component: {
                        name: 'image-modal',
                        props: ['image'],

                        template: `
                            <div>
                                <img :src="image.url" :alt="image.filename">
                            </div>
                        `
                    }
                });
            },

            ...mapActions({
                addToCart: 'cart/addToCart'
            })
        }
    }
</script>

<style lang="scss">
    .vuedal img {
        max-width: 100%;
        height: auto;
    }

    ul.product-variants {
        list-style: none;
        padding-left: 0px;
        margin-bottom: 10px;
    }
</style>
